import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import LuckyDrawPageComponent from "./luckyDraw.page";
import {AccessRights} from "lib/constants/accessRights";
import { useHistory } from "react-router-dom";
import {
  INSTANT_WIN_CREATE,
  LUCKY_DRAW_CREATE,
  TRADITIONAL_RAFFLE_LIST,
  INSTANT_WIN_LIST,
} from "modules/lucky-draw-v2/config/lucky-draw-v2.route";
import { LuckyDrawProvider } from "../../context/luckyDraw.context";
import { setListingActiveTab } from "../../redux";
import {canAccess} from "../../../profile/redux/selector/profile.selector";

function LuckyDrawPageContainer({ defaultTab = 0 }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const lang = useSelector((state) => state.constant.languages);
  const canAddTraditionalRaffle = useSelector((state) =>
    canAccess(state, AccessRights.CampaignV2.LUCKY_DRAW_LIST_WRITE_CREATE_TRADITIONAL_RAFFLE)
  );
  const canAddInstantWin = useSelector((state) =>
    canAccess(state, AccessRights.CampaignV2.LUCKY_DRAW_LIST_WRITE_CREATE_INSTANT_WIN)
  );
  const canDuplicate = useSelector((state) =>
    canAccess(state, AccessRights.CampaignV2.LUCKY_DRAW_LIST_WRITE_DUPLICATE)
  );
  const activeTab = useSelector((state) => state.luckyDrawListing.activeTab);

  // Sync Redux state with URL on mount
  useEffect(() => {
    if (activeTab !== defaultTab) {
      dispatch(setListingActiveTab(defaultTab));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultTab, dispatch]);

  // Handle tab change and update URL
  const handleTabChangeFromPanel = (newTab) => {
    if (newTab === 0) {
      history.push(TRADITIONAL_RAFFLE_LIST);
    } else {
      history.push(INSTANT_WIN_LIST);
    }
  };

  const handleAddLuckyDraw = () => {
    history.push(LUCKY_DRAW_CREATE);
  };
  const handleAddInstantWin = () => {
    history.push(INSTANT_WIN_CREATE);
  };

  return (
    <>
      <LuckyDrawProvider>
        <LuckyDrawPageComponent
          canAddTraditionalRaffle={canAddTraditionalRaffle}
          canAddInstantWin={canAddInstantWin}
          canDuplicate={canDuplicate}
          handleAddLuckyDraw={handleAddLuckyDraw}
          handleAddInstantWin={handleAddInstantWin}
          lang={lang}
          activeTab={activeTab}
          onTabChange={handleTabChangeFromPanel}
        />
      </LuckyDrawProvider>
    </>
  );
}

export default LuckyDrawPageContainer;
